import apiClient from "./ApiClient";

/**
 * Fetch subscriptions for a restaurant with pagination
 */
export function fetchSubscriptionsByRestaurant(restaurantId, page, size) {
  return apiClient
    .get(`/subscription/restaurant/${restaurantId}`, { params: { page, size } })
    .then((res) => res.data);
}

/**
 * Create a new subscription
 */
export function createSubscription(payload) {
  return apiClient.post("/subscription/create", payload).then((res) => res.data);
}

/**
 * Update an existing subscription
 */
export function updateSubscription(id, payload) {
  return apiClient.put(`/subscription/${id}`, payload).then((res) => res.data);
}

/**
 * Fetch a subscription by ID
 */
export function fetchSubscriptionById(id) {
  return apiClient.get(`/subscription/${id}`).then((res) => res.data);
}

/**
 * Delete multiple subscriptions
 */
export function deleteSubscriptionsBatch(ids) {
  return apiClient
    .delete("/subscription/batch-delete", { data: ids })
    .then((res) => res.data);
}